import { ITheme } from '@uifabric/styling';
import RequestStatus from '../store/schema/RequestStatus';
import { getFooterItemProps, getHeaderItemProps } from './getHeaderFooterProps';
import { IBaseFloatingPickerSuggestionProps } from '@fluentui/react/lib/FloatingPicker';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import loc from 'owa-localize';
import { locationSuggestionsAvailableAlert } from './getSuggestionProps.locstring.json';

const styles = require('../components/LocationSuggestionItem.scss');

export default function getSuggestionProps(
    queryString: string,
    findLocationRequestStatus: RequestStatus,
    numOfSuggestions: number,
    theme: ITheme,
    colorScheme: ColorScheme,
    disableUseThisLocationButton: boolean,
    onUseThisLocationClicked: (locationString: string) => void,
    showAddRoom: boolean,
    onAddRoomClicked: () => void,
    canRemoveSuggestion: boolean
): IBaseFloatingPickerSuggestionProps {
    // className isn't explicitly exposed on the whitelisted props passed to the
    // Suggestion by the ExtendedPicker.
    const extraProps = {
        className: styles.containsCustomRemoveButton,
        suggestionsAvailableAlertText: loc(locationSuggestionsAvailableAlert),
    } as Partial<IBaseFloatingPickerSuggestionProps>;
    return {
        ...extraProps,
        showRemoveButtons: canRemoveSuggestion,
        headerItemsProps: getHeaderItemProps(
            queryString,
            numOfSuggestions,
            colorScheme,
            disableUseThisLocationButton,
            onUseThisLocationClicked
        ),

        footerItemsProps: getFooterItemProps(
            queryString,
            findLocationRequestStatus,
            numOfSuggestions,
            theme,
            showAddRoom,
            onAddRoomClicked
        ),
        shouldSelectFirstItem: () => {
            return false;
        },
    };
}
